<template>
  <BaseCardV2
    :has-btn-action="false"
    class="pa-2"
    has-help
    titre="Répartition des grandes cultures"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading.repartitionAdherent" />
      <BaseMessageServerError
        v-if="erreur.repartitionAdherent || erreur.repartitionGroupe"
        class="mx-5 my-2"
      />
      <RepartitionBarHorizontal
        v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
        v-model="valueCode"
        class="my-5 mx-3"
        :data="{
          items: items
        }"
        unit="ha"
      />
      <div class="bottom">
        <v-divider
          v-if="!loading.repartitionAdherent"
          class="my-6 mx-3"
        />
        <div class="d-flex justify-space-between mx-3">
          <div
            v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
            class="d-flex flex-column"
          >
            <div class="titre-h4 texte-gris-fonce mb-2">
              Total grandes cultures
            </div>
            <div class="d-flex">
              <span class="titre-h3 align-self-center secondary--text mr-2">{{ repartitionGrandesCultures.surfaceTotaleEnHectare | roundNumber(0) | splitNumber }} ha</span>
              <BaseEvolutionWithInfo
                v-if="repartitionGrandesCultures.evolutionSurfaceTotaleEnPourcentage != null"
                :evolution-value="repartitionGrandesCultures.evolutionSurfaceTotaleEnPourcentage"
                :values="repartitionGrandesCultures.surfaceTotaleParAnnee"
                :unite="'ha'"
              />
            </div>
          </div>
          <div class="ml-auto">
            <UserIndicatorJauge
              v-if="!loading.repartitionAdherent && !erreur.repartitionGroupe"
              :chargement="loading.repartitionGroupe"
              :data="{
                value: positionJaugeGroupe(repartitionGrandesCulturesGroupe?.codePositionDuNumtiers)
              }"
              :unite="'ha'"
              :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
              :data-groupe="repartitionGrandesCulturesGroupe?.valeurMoyenneDuGroupe"
              :negative-color="repartitionGrandesCulturesGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
              :positive-color="repartitionGrandesCulturesGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
            />
          </div>
        </div>
      </div>

      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition des grandes cultures"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-8">
            <p>Visualisez la répartition des surfaces de vos grandes cultures.</p>
            <p>
              Comparez le total de la surface de grandes cultures par rapport aux années précédentes et à un groupe de comparaison (au niveau du compteur).
            </p>
            <p>
              Le quart supérieur du groupe est matérialisé en vert, le quart inférieur est lui, en orange. Quant aux valeurs intermédiaires (entre 25 et 75% des valeurs du groupe), elle sont affichées en grises.
            </p>
          </div>
        </div>
      </HelpModal>
    </div>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import { mapActions, mapGetters } from 'vuex'
import { round } from 'lodash'
import BaseLoader from '@/components/common/base-loader.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import RepartitionBarHorizontal from '@/components/chart/v2/repartition-bar-horizontal.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import { isPanneServeur } from '@/utils/requete'

export default {
  name: 'RepartitionGrandesCultures',
  components: {BaseEvolutionWithInfo, BaseLoader, BaseCardV2, BaseMessageServerError, RepartitionBarHorizontal, HelpModal, UserIndicatorJauge },
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      loading: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      erreur: {
        repartitionAdherent: false,
        repartitionGroupe: false
      }
    }
  },

  computed: {
    ...mapGetters({
      codeCultureMiseEnValeur: 'app/codeCultureMiseEnValeur',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      repartitionGrandesCultures: 'culture/repartitionGrandesCultures',
      repartitionGrandesCulturesGroupe: 'culture/repartitionGrandesCulturesGroupe',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
    }),
    valueCode: {
      get () {
        return this.codeCultureMiseEnValeur
      },
      set (codeTypeCulture) {
        this.mettreEnValeurCulture(codeTypeCulture)
      }
    },
    items () {
      return this.repartitionGrandesCultures.cultures.map((item) => ({
        code: item.codeTypeCulture,
        label: item.libelleTypeCulture,
        value: round(item.surfaceTotaleEnHectare,2),
        percentage: item.surfaceTotaleEnPourcentage
      }))
    }
  },
  watch: {
    anneeRecolteSelected: {
      handler () {
        this.loadRepartitionAdherent()
        this.loadRepartitionGroupe()
      },
      immediate: true
    },
    codeGraineRs3Selected () {
      this.loadRepartitionAdherent()
      this.loadRepartitionGroupe()
    },
    filtresAdherent () {
      this.loadRepartitionGroupe()
    }
  },
  methods: {
    ...mapActions({
      mettreEnValeurCulture: 'app/mettreEnValeurCulture',
      getRepartitionDesGrandesCultures: 'culture/getRepartitionDesGrandesCultures',
      getRepartitionDesGrandesCulturesGroupe: 'culture/getRepartitionDesGrandesCulturesGroupe'
    }),
    loadRepartitionAdherent () {
      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getRepartitionDesGrandesCultures()
        .catch(erreur => this.erreur.repartitionAdherent = isPanneServeur(erreur))
        .finally(() => this.loading.repartitionAdherent = false)
    },
    loadRepartitionGroupe () {
      this.loading.repartitionGroupe = true
      this.erreur.repartitionGroupe = false
      this.getRepartitionDesGrandesCulturesGroupe()
        .catch(erreur => this.erreur.repartitionGroupe = isPanneServeur(erreur))
        .finally(() => this.loading.repartitionGroupe = false)
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    }
  }
}

</script>

<style lang="scss" scoped>
.picto-ferme {
  width: 32%;
}
.positif-color {
  color: #dbbd00;
}
.negatif-color {
  color: #ec6608;
}
</style>
